<template>
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29.5"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="11.5"
      cy="52"
      r="3"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      class="a-fill"
      cx="47.5"
      cy="7"
      r="3"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M29.7738 15.9575C30.1511 15.7958 30.5782 15.7958 30.9556 15.9576L42.1285 20.7471C42.68 20.9835 43.0376 21.5258 43.0376 22.1258L43.0376 34.5986C43.0376 35.1783 42.7034 35.7062 42.1794 35.9543L31.0064 41.2441C30.6002 41.4364 30.1291 41.4365 29.7229 41.2442L18.5454 35.9542C18.0213 35.7061 17.6871 35.1782 17.6871 34.5983V22.126C17.6871 21.5259 18.0447 20.9836 18.5963 20.7473L29.7738 15.9575Z"
      stroke="#142B6F"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M21.9668 22.9937L29.5984 26.0463L37.23 22.9937"
      stroke="#142B6F"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
  &.a-fill {
    fill: #CDD1DE;
  }
}

.a-active {
  &.a-fill {
      fill: #142B6F;
  }
}
</style>
